<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left m-0">
            Sincronizando Usuários
          </h4>

          <div
            class="tab-content"
            id="pills-tabContent"
            style="min-height: 100px;"
          >
            <div class="tab-pane fade show active">
              <div class="row justify-content-center mt-2">
                <div class="row w-100 mt-2">
                  <div class="col-sm-12">
                    <p class="text-muted text-start">
                      <strong>Sincronização Completa:</strong> Sincroniza o
                      cadastro de todos os funcionários entre o REP 671 e o
                      relógio.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row d-flex justify-content-start mt-3">
            <div class="col-sm-3">
              <base-button
                block
                type="success"
                @click="sincUsuariosRepParaRelogio"
                :disabled="validateForm()"
              >
                Rep 671 para Relógio
              </base-button>
            </div>
            <div class="col-sm-3">
              <base-button
                block
                type="success"
                @click="sincUsuarios"
                :disabled="validateForm()"
              >
                Relógio para Rep 671
              </base-button>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="vld-parent">
      <loading-overlay
        :percentage="loadingPercentage"
        :isVisible="isLoadingIndicator"
      />
    </div>
  </div>
</template>

<script>
import { Card } from "@/components/index";
import swal from "sweetalert2";
import LoadingOverlay from "../../components/Loaging/LoadingOverlay.vue";

const https = require("https");

const httpsAgent = new https.Agent({
  rejectUnauthorized: false,
});

export default {
  components: {
    Card,
    LoadingOverlay,
  },

  data() {
    return {
      isLoadingIndicator: false,
      loadingPercentage: 0,
      dadosRelogio: {
        ip: "",
        session: "",
        id_empregador: "",
        tipoAfd: "",
        modelo: "",
        porta: "",
        usuario: "",
        senha: "",
      },
      templateFuncionario: [],
    };
  },

  mounted() {
    this.carregaDadosRelogio(this.$route.params.id);
  },

  methods: {
    validateForm() {
      return !this.dadosRelogio.session;
    },

    listarEmpregados() {
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      return this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          this.templateFuncionario = response.data.data.dados.filter(
            (fun) => fun.id_empregador === this.dadosRelogio.id_empregador,
          );
        })
        .catch((err) => {
          console.error("Erro ao listar empregados:", err);
          this.templateFuncionario = [];
        });
    },

    sincUsuariosRepParaRelogio() {
      this.isLoadingIndicator = true;
      this.loadingPercentage = 1;

      let promise;
      if (this.dadosRelogio.modelo === "IDFace/ IDFlex (Coletor REP-P)") {
        promise = this.sincUserRepRelIdFace();
      } else {
        promise = this.listarEmpregados().then(() => {
          return this.sincUserRepRelIdClass();
        });
      }

      promise
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoadingIndicator = false;
          this.loadingPercentage = 0;
        });
    },

    addUserService(form) {
      return this.axios
        .post(`https://${this.dadosRelogio.ip}/add_users.fcgi`, form, {
          httpsAgent,
        })
        .catch((err) => {
          console.error("Erro ao adicionar usuário no IDClass:", err);
        });
    },

    sincUserRepRelIdClass() {
      const total = this.templateFuncionario.length;
      if (total === 0) {
        this.showSwal(
          "auto-close",
          "Aviso",
          "Nenhum usuário encontrado para sincronizar.",
          "warning",
        );
        return Promise.resolve();
      }

      let sequence = Promise.resolve();
      for (let i = 0; i < total; i++) {
        const fun = this.templateFuncionario[i];
        sequence = sequence.then(() => {
          const cleanCpf = String(fun.cpf || "").replace(/\D/g, "");
          const cleanPis = String(fun.numero_pis || "").replace(/\D/g, "");
          const funcionario = {
            name: fun.nome,
            pis: cleanCpf ? Number(cleanCpf) : Number(cleanPis),
            registration: 0,
            bars: "",
            rfid: 0,
            code: 0,
            password: "",
            admin: false,
            templates: [],
            remove_templates: false,
          };
          const form = {
            users: [funcionario],
            session: this.dadosRelogio.session,
          };
          return this.addUserService(form).then(() => {
            this.loadingPercentage = Math.round(((i + 1) / total) * 100);
          });
        });
      }

      return sequence.then(() => {
        this.showSwal(
          "auto-close",
          "Sucesso",
          "Usuários sincronizados com sucesso no relógio",
          "success",
        );
      });
    },

    sincUserRepRelIdFace() {
      const form = {
        object: "users",
      };
      return this.axios
        .post(
          `https://${this.dadosRelogio.ip}:${this.dadosRelogio.porta}/load_objects.fcgi?session=${this.dadosRelogio.session}`,
          form,
          { httpsAgent },
        )
        .then((res) => {
          const usersRel = res.data.users.map((us) => {
            return {
              nome: us.name,
              pis: us.id,
              cpf: us.id,
            };
          });

          this.loadingPercentage = 10;

          const bodyFormData = {
            setDB: this.$cookies.get("db"),
          };
          return this.axios
            .post("/api/empregado/listarEmpregados2", bodyFormData, {
              headers: {
                "id-actor": this.$cookies.get("id_actor"),
                "tipo-actor": this.$cookies.get("tipo_actor"),
              },
            })
            .then((response) => {
              const usersRep = response.data.data.dados.filter(
                (fun) => fun.id_empregador === this.dadosRelogio.id_empregador,
              );

              this.loadingPercentage = 20;

              const toSync = [];
              usersRep.forEach((el) => {
                const cleanCpf = Number(
                  String(el.cpf || "").replace(/\D/g, ""),
                );
                if (
                  cleanCpf &&
                  !usersRel.find((e) => Number(e.cpf) === cleanCpf)
                ) {
                  toSync.push({
                    id: cleanCpf,
                    name: el.nome,
                    registration: String(cleanCpf).padStart(11, "0"),
                    password: "",
                    salt: "",
                    begin_time: 0,
                    end_time: 0,
                    user_type_id: null,
                  });
                }
              });

              this.loadingPercentage = 30;

              const uniqueObjects = {};
              toSync.forEach((obj) => {
                uniqueObjects[obj.id] = obj;
              });
              const uniqueToSync = Object.values(uniqueObjects);

              this.loadingPercentage = 50;

              if (uniqueToSync.length > 0) {
                this.loadingPercentage = 60;
                const createForm = {
                  join: "LEFT",
                  object: "users",
                  fields: [
                    "id",
                    "name",
                    "registration",
                    "password",
                    "salt",
                    "begin_time",
                    "end_time",
                    "user_type_id",
                    "last_access",
                  ],
                  where: [],
                  order: ["name"],
                  values: uniqueToSync,
                };

                return this.axios
                  .post(
                    `https://${this.dadosRelogio.ip}:${this.dadosRelogio.porta}/create_objects.fcgi?session=${this.dadosRelogio.session}`,
                    createForm,
                    { httpsAgent },
                  )
                  .then(() => {
                    this.loadingPercentage = 100;
                    this.showSwal(
                      "auto-close",
                      "Sucesso",
                      "Usuários sincronizados com sucesso",
                      "success",
                    );
                  });
              } else {
                this.loadingPercentage = 100;
                this.showSwal(
                  "auto-close",
                  "Sucesso",
                  "Todos os usuários já foram sincronizados!",
                  "success",
                );
              }
            });
        })
        .catch((err) => {
          console.error("Erro na sincronização IDFace:", err);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao sincronizar com o relógio!",
            "error",
          );
        });
    },

    async sincUsuarios() {
      this.isLoadingIndicator = true;
      this.loadingPercentage = 1;
      let promise;
      if (this.dadosRelogio.modelo === "IDFace/ IDFlex (Coletor REP-P)") {
        promise = this.buscarUsuarioFaceId();
      } else {
        promise = this.buscarQuantUser();
      }

      promise
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoadingIndicator = false;
          this.loadingPercentage = 0;
        });
    },

    buscarUsuarioFaceId() {
      const form = {
        object: "users",
      };
      return this.axios
        .post(
          `https://${this.dadosRelogio.ip}:${this.dadosRelogio.porta}/load_objects.fcgi?session=${this.dadosRelogio.session}`,
          form,
          { httpsAgent },
        )
        .then((res) => {
          const users = res.data.users.map((us) => {
            return {
              nome: us.name,
              pis: us.id,
              cpf: us.id,
            };
          });

          this.loadingPercentage = 50;
          return this.sincronizarUsuarios(users);
        })
        .catch((err) => {
          console.error(err);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao sincronizar com o relógio!",
            "error",
          );
        });
    },

    sincronizarUsuarios(users) {
      const normalizedUsers = users.map((us) => {
        if (!us) return null;
        const cleanCpf = String(us.cpf || "")
          .replace(/\D/g, "")
          .padStart(11, "0");
        const cleanPis = String(us.pis || "")
          .replace(/\D/g, "")
          .padStart(11, "0");
        return {
          ...us,
          cpf: cleanCpf,
          pis: cleanPis,
        };
      });

      const form = {
        setDB: this.$cookies.get("db"),
        users: normalizedUsers.filter((e) => e != null),
        id_empregador: this.dadosRelogio.id_empregador,
      };

      return this.axios
        .post("/api/sincronizando/usuarios", form)
        .then((res) => {
          if (res.data.status === "success") {
            this.showSwal(
              "auto-close",
              "Sucesso",
              `${res.data.message}`,
              "success",
            );
          } else {
            this.showSwal("auto-close", "Erro", `${res.data.err}`, "error");
          }
        })
        .catch((err) => {
          console.error("Erro ao sincronizar usuários com a API:", err);
          this.showSwal(
            "auto-close",
            "Erro",
            "Ocorreu algum erro ao sincronizar os usuários!",
            "error",
          );
        })
        .finally(() => {
          setTimeout(() => {
            this.$router.push("/controlId");
          }, 3000);
        });
    },

    buscarQuantUser() {
      const form = {
        session: this.dadosRelogio.session,
      };

      return this.axios
        .post(`https://${this.dadosRelogio.ip}/count_users.fcgi`, form, {
          httpsAgent,
        })
        .then((res) => {
          const count = res.data.count;
          this.loadingPercentage = 10;

          const usuariosRelogio = [];
          let offset = 0;

          const loadNextBatch = () => {
            if (offset >= count) {
              return Promise.resolve();
            }
            const loadForm = {
              limit: 100,
              offset: offset,
              session: this.dadosRelogio.session,
            };
            offset += 100;
            return this.axios
              .post(
                `https://${this.dadosRelogio.ip}/load_users.fcgi`,
                loadForm,
                { httpsAgent },
              )
              .then((loadRes) => {
                if (loadRes.data && loadRes.data.users) {
                  usuariosRelogio.push(...loadRes.data.users);
                }
                this.loadingPercentage =
                  10 + Math.min(Math.round((offset / count) * 40), 40);
                return loadNextBatch();
              });
          };

          return loadNextBatch().then(() => {
            const isAfd671 = this.dadosRelogio.tipoAfd === "671";
            const users = usuariosRelogio
              .filter((us) => us.name !== "ADM")
              .map((us) => {
                const cleanCpf = String(
                  isAfd671 ? us.cpf : us.pis || "",
                ).replace(/\D/g, "");
                return {
                  nome: us.name,
                  pis: Number(cleanCpf),
                  cpf: Number(cleanCpf),
                };
              });

            this.loadingPercentage = 60;
            return this.sincronizarUsuarios(users);
          });
        })
        .catch((err) => {
          console.error("Erro ao carregar usuários do relógio:", err);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar usuários do relógio",
            "error",
          );
        });
    },

    carregaDadosRelogio(id) {
      this.isLoadingIndicator = true;
      const form = {
        setDB: this.$cookies.get("db"),
        id: id,
      };
      this.axios
        .post("/api/relogio/listarRelogios/id", form)
        .then((response) => {
          if (
            response.data &&
            response.data.data &&
            response.data.data.dados &&
            response.data.data.dados[0]
          ) {
            const {
              ip,
              sessao,
              id_empregador,
              tipoAfd,
              modelo,
              porta,
              senha,
              usuario,
            } = response.data.data.dados[0];
            this.dadosRelogio.ip = ip;
            this.dadosRelogio.session = sessao;
            this.dadosRelogio.id_empregador = id_empregador;
            this.dadosRelogio.tipoAfd = tipoAfd;
            this.dadosRelogio.modelo = modelo;
            this.dadosRelogio.porta = porta;
            this.dadosRelogio.senha = senha;
            this.dadosRelogio.usuario = usuario;
          }
        })
        .catch((err) => {
          console.error("Erro ao carregar dados do relógio:", err);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar dados do relógio",
            "error",
          );
        })
        .finally(() => {
          this.isLoadingIndicator = false;
          this.loadingPercentage = 0;
        });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
  },
};
</script>

<style scoped></style>
